import React, { useState } from 'react';
import SectionHeading from '../components/SectionHeading';
import { Mail, Phone, MapPin, Clock, Send } from 'lucide-react';
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real application, this would submit the form data to a server
    setIsSubmitted(true);
    // Reset form after submission
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };
  return <div className="w-full" data-id="element-898">
      {/* Hero Section */}
      <section className="bg-navy text-white py-16" data-id="element-899">
        <div className="container-custom text-center" data-id="element-900">
          <h1 className="text-4xl md:text-5xl font-bold font-montserrat mb-6" data-id="element-901">
            Contact Us
          </h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-902">
            Have questions about Operation Launchpad? We're here to help.
          </p>
        </div>
      </section>
      {/* Contact Information */}
      <section className="section-padding" data-id="element-903">
        <div className="container-custom" data-id="element-904">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-905">
            <ContactCard icon={<Mail size={32} data-id="element-907" />} title="Email Us" details={['info@operationlaunchpad.org', 'support@operationlaunchpad.org']} action={{
            text: 'Send Email',
            link: 'mailto:info@operationlaunchpad.org'
          }} data-id="element-906" />
            <ContactCard icon={<Phone size={32} data-id="element-909" />} title="Call Us" details={['(555) 123-4567', 'Monday-Friday, 9am-5pm ET']} action={{
            text: 'Call Now',
            link: 'tel:5551234567'
          }} data-id="element-908" />
            <ContactCard icon={<MapPin size={32} data-id="element-911" />} title="Our Location" details={['123 Entrepreneur Way', 'Business City, TX 12345']} action={{
            text: 'Get Directions',
            link: '#'
          }} data-id="element-910" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-912">
            {/* Contact Form */}
            <div className="bg-white rounded-lg shadow-lg p-8" data-id="element-913">
              <h2 className="text-2xl font-bold text-navy mb-6 font-montserrat" data-id="element-914">
                Send Us a Message
              </h2>
              {isSubmitted ? <div className="bg-green-50 border border-green-200 text-green-700 rounded-lg p-6 text-center" data-id="element-915">
                  <div className="flex justify-center mb-4" data-id="element-916">
                    <div className="bg-green-100 rounded-full p-2" data-id="element-917">
                      <Send size={24} className="text-green-600" data-id="element-918" />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-2" data-id="element-919">Message Sent!</h3>
                  <p data-id="element-920">
                    Thank you for contacting Operation Launchpad. We'll respond
                    to your inquiry as soon as possible.
                  </p>
                  <button onClick={() => setIsSubmitted(false)} className="mt-4 text-green-700 hover:text-green-800 font-medium underline" data-id="element-921">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-922">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-923">
                    <div data-id="element-924">
                      <label htmlFor="name" className="block text-darkGray font-medium mb-2" data-id="element-925">
                        Your Name *
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange" data-id="element-926" />
                    </div>
                    <div data-id="element-927">
                      <label htmlFor="email" className="block text-darkGray font-medium mb-2" data-id="element-928">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange" data-id="element-929" />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-930">
                    <div data-id="element-931">
                      <label htmlFor="phone" className="block text-darkGray font-medium mb-2" data-id="element-932">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange" data-id="element-933" />
                    </div>
                    <div data-id="element-934">
                      <label htmlFor="subject" className="block text-darkGray font-medium mb-2" data-id="element-935">
                        Subject *
                      </label>
                      <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange" data-id="element-936" />
                    </div>
                  </div>
                  <div data-id="element-937">
                    <label htmlFor="message" className="block text-darkGray font-medium mb-2" data-id="element-938">
                      Your Message *
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange" data-id="element-939"></textarea>
                  </div>
                  <div className="pt-4" data-id="element-940">
                    <button type="submit" className="btn-primary" data-id="element-941">
                      Send Message
                    </button>
                  </div>
                </form>}
            </div>
            {/* FAQ and Hours */}
            <div data-id="element-942">
              <div className="bg-lightGray rounded-lg p-8 mb-8" data-id="element-943">
                <h3 className="text-xl font-bold text-navy mb-4 font-montserrat flex items-center" data-id="element-944">
                  <Clock size={20} className="mr-2" data-id="element-945" />
                  Office Hours
                </h3>
                <div className="space-y-3" data-id="element-946">
                  <div className="flex justify-between" data-id="element-947">
                    <span className="font-medium" data-id="element-948">Monday - Friday</span>
                    <span data-id="element-949">9:00 AM - 5:00 PM ET</span>
                  </div>
                  <div className="flex justify-between" data-id="element-950">
                    <span className="font-medium" data-id="element-951">Saturday</span>
                    <span data-id="element-952">By appointment only</span>
                  </div>
                  <div className="flex justify-between" data-id="element-953">
                    <span className="font-medium" data-id="element-954">Sunday</span>
                    <span data-id="element-955">Closed</span>
                  </div>
                </div>
              </div>
              <div className="bg-navy text-white rounded-lg p-8" data-id="element-956">
                <h3 className="text-xl font-bold text-gold mb-6 font-montserrat" data-id="element-957">
                  Quick Questions
                </h3>
                <div className="space-y-6" data-id="element-958">
                  <div data-id="element-959">
                    <h4 className="font-bold mb-2" data-id="element-960">
                      How do I apply to the program?
                    </h4>
                    <p className="text-gray-300" data-id="element-961">
                      Visit our{' '}
                      <a href="/apply" className="text-gold hover:underline" data-id="element-962">
                        Apply page
                      </a>{' '}
                      to submit your application. We'll review your information
                      and contact you for next steps.
                    </p>
                  </div>
                  <div data-id="element-963">
                    <h4 className="font-bold mb-2" data-id="element-964">
                      What are the program costs?
                    </h4>
                    <p className="text-gray-300" data-id="element-965">
                      We offer our solutions at discounted or no upfront cost.
                      Instead, we take a vested interest in your success through
                      future billing once your business is generating revenue.
                    </p>
                  </div>
                  <div data-id="element-966">
                    <h4 className="font-bold mb-2" data-id="element-967">
                      Who is eligible to apply?
                    </h4>
                    <p className="text-gray-300" data-id="element-968">
                      Our program is open to all committed entrepreneurs across
                      various industries who are dedicated to building
                      successful businesses.
                    </p>
                  </div>
                </div>
                <div className="mt-6" data-id="element-969">
                  <a href="/about" className="text-gold hover:underline font-medium" data-id="element-970">
                    Learn more about our program →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Map Section */}
      <section className="h-96 bg-gray-200" data-id="element-971">
        <div className="w-full h-full flex items-center justify-center" data-id="element-972">
          <div className="text-center" data-id="element-973">
            <p className="text-darkGray mb-2" data-id="element-974">Map placeholder</p>
            <p className="text-sm text-gray-500" data-id="element-975">
              123 Entrepreneur Way, Business City, TX 12345
            </p>
          </div>
        </div>
      </section>
    </div>;
};
const ContactCard = ({
  icon,
  title,
  details,
  action
}) => {
  return <div className="bg-white rounded-lg shadow-lg p-6 text-center flex flex-col h-full" data-id="element-976">
      <div className="bg-lightGray rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4 text-navy" data-id="element-977">
        {icon}
      </div>
      <h3 className="text-xl font-bold text-navy mb-3 font-montserrat" data-id="element-978">
        {title}
      </h3>
      <div className="mb-6 flex-grow" data-id="element-979">
        {details.map((detail, index) => <p key={index} className="text-darkGray" data-id="element-980">
            {detail}
          </p>)}
      </div>
      <a href={action.link} className="text-orange hover:text-navy font-bold transition duration-300" data-id="element-981">
        {action.text}
      </a>
    </div>;
};
export default ContactPage;